export default function CTASection() {
  return (
    <section className="py-16 bg-gradient-to-br from-orange-500 via-red-500 to-orange-600">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
          業界最高水準1.2%還元を今すぐ体験
        </h2>
        <p className="text-xl text-white/90 mb-8">
          年会費永年無料で、いつでもどこでも高還元率。<br className="hidden md:block" />
          新規入会&利用で最大6,000円分のポイントプレゼント中
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
          <div className="bg-white/20 backdrop-blur-sm rounded-xl px-6 py-4 text-white">
            <div className="flex items-center gap-2">
              <i className="ri-percent-line text-2xl w-6 h-6 flex items-center justify-center"></i>
              <div className="text-left">
                <p className="text-sm opacity-90">基本還元率</p>
                <p className="text-2xl font-bold">1.2%</p>
              </div>
            </div>
          </div>
          <div className="bg-white/20 backdrop-blur-sm rounded-xl px-6 py-4 text-white">
            <div className="flex items-center gap-2">
              <i className="ri-money-dollar-circle-line text-2xl w-6 h-6 flex items-center justify-center"></i>
              <div className="text-left">
                <p className="text-sm opacity-90">年会費</p>
                <p className="text-2xl font-bold">永年無料</p>
              </div>
            </div>
          </div>
          <div className="bg-white/20 backdrop-blur-sm rounded-xl px-6 py-4 text-white">
            <div className="flex items-center gap-2">
              <i className="ri-gift-line text-2xl w-6 h-6 flex items-center justify-center"></i>
              <div className="text-left">
                <p className="text-sm opacity-90">入会特典</p>
                <p className="text-2xl font-bold">最大6,000円</p>
              </div>
            </div>
          </div>
        </div>
        <a
          href="https://px.a8.net/svt/ejp?a8mat=4AXB0E+3PYKNU+4T5W+5YRHE"
          target="_blank"
          rel="nofollow noopener noreferrer"
          className="inline-block bg-white text-orange-600 font-bold text-lg px-10 py-5 rounded-xl hover:bg-gray-50 transition-all duration-300 shadow-2xl hover:shadow-3xl hover:scale-105 whitespace-nowrap cursor-pointer"
        >
          公式サイトで今すぐ申込む
          <i className="ri-arrow-right-line ml-2"></i>
        </a>
        <p className="text-white/80 text-sm mt-6">
          ※最短1週間で発行。18歳以上（高校生を除く）の方が対象です
        </p>
      </div>
    </section>
  );
}
